// extracted by mini-css-extract-plugin
export default {"Blog":"Blog_Blog__W9wfi","Wrapper":"Blog_Wrapper__jhpG8","Loading":"Blog_Loading__3NJMo","Reload":"Blog_Reload__lr-pw"};